import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { FullScreenExitIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const FullScreenExitIconButton = forwardRef<
  HTMLButtonElement,
  ExtendedIconButtonProps
>(({ tooltipTitle, ...props }, ref) => {
  const { t } = useTranslation();
  const resolvedTooltipTitle =
    tooltipTitle ?? t('common.full_screen_exit', 'Full screen exit');

  return (
    <IconButton ref={ref} {...props} tooltipTitle={resolvedTooltipTitle}>
      <FullScreenExitIcon color="inherit" />
    </IconButton>
  );
});

FullScreenExitIconButton.displayName = 'FullScreenExitIconButton';
export default FullScreenExitIconButton;
